const devices = {
  name: 'Device |||| Devices',
  list: {
    title: 'Device List',
    empty: 'No devices registered',
  },
  create: {
    title: 'Create Device',
    subtitle: 'Register a new device in the system',
  },
  edit: {
    title: 'Edit Device',
  },
  fields: {
    installationCode: 'Installation Code',
    hotel: 'Property',
    group: 'Group',
    deviceType: 'Device Type',
    channel: 'Channel',
    status: 'Status',
    source: 'Source',
    serialNumber: 'Serial Number',
    name: 'Name',
    metadata: 'Metadata',
    registeredAt: 'Registration Date',
    lastSeenAt: 'Last Seen',
    apiKey: 'API Key',
    category: 'Category',
  },
  // Labels for raw metadata keys surfaced in the device list/detail (F-B-014):
  // no internal product name may reach the UI verbatim. Unmapped keys fall
  // back to a humanised version of the key itself (see DeviceList.tsx).
  metadataKeys: {
    deviceId: 'Device ID',
    establishmentId: 'Property ID',
    groupId: 'Group ID',
    model: 'Model',
    firmware: 'Firmware',
  },
  // Compact presence indicator for the metadata column (F-B-015): the full
  // pairs live in the device detail (DeviceEdit.tsx).
  metadataCount: '%{smart_count} value |||| %{smart_count} values',
  filters: {
    search: 'Search by code',
    hotel: 'Property',
    group: 'Group',
    deviceType: 'Type',
    status: 'Status',
    source: 'Source',
    channel: 'Channel',
    metadataKey: 'Metadata Key',
    metadataValue: 'Metadata Value',
    metadataSearch: 'Search by Metadata',
    metadataSearchHint: 'Enter both key and value to search',
  },
  actions: {
    create: 'Create Device',
    showApiKey: 'Show API Key',
    hideApiKey: 'Hide API Key',
    deactivate: 'Deactivate',
    forceDelete: 'Force Delete',
    forceDeleteConfirm: 'Delete Permanently',
    generateOtp: 'Generate OTP',
    copyOtp: 'Copy',
    viewLogs: 'View Logs',
  },
  sections: {
    basicInfo: 'Basic Information',
    assignment: 'Assignment',
    readOnlyInfo: 'Device Information',
    readOnlySubtitle: 'View device details and registration information',
    editableFields: 'Editable Fields',
    editableSubtitle: 'Modify device assignment and status',
  },
  hints: {
    installationCode: 'Enter the device installation code',
    groupOptional: 'Optionally assign to a group',
    changeHotel: 'Change the property assignment',
    changeGroup: 'Change the group assignment',
    changeStatus: 'Change the device status',
    changeChannel: 'Change the device channel',
    deviceType: 'Select the type of device',
    channel: 'Select the communication channel',
    category: 'Select the device category',
    serialNumber: 'Hardware serial number (required for OTP)',
    name: 'Optional friendly name for this device',
  },
  messages: {
    createInfo: 'Fill in the information to register a new device',
    createWarning: 'The device will be created in pending activation status',
    createSuccess: 'Device created successfully',
    editInfo: 'Modify the editable fields of the device',
    updateSuccess: 'Device updated successfully',
    deactivateConfirm: 'Are you sure you want to deactivate this device?',
    deactivateWarning: 'The device will no longer be able to access the system',
    deactivateInfo: 'Device deactivated successfully',
    alreadyInactive: 'Device is already inactive',
    deleteError: 'Error deactivating device',
    // Force delete messages
    forceDeleteCaption: 'Permanently delete device and all data',
    forceDeleteConfirm: 'Force Delete Device',
    forceDeleteDanger: 'This action is IRREVERSIBLE and will permanently delete ALL data.',
    forceDeleteWarning: 'Are you sure you want to permanently delete device "%{installationCode}" and ALL its associated data?',
    forceDeleteWillRemove: 'This will permanently delete',
    forceDeleteComplete: 'Device and all associated data have been permanently deleted.',
    forceDeleteSummary: 'Deletion summary',
    forceDeleteSuccess: 'Device force deleted successfully',
    forceDeleteError: 'Error force deleting device',
    allJourneys: 'All check-in journeys',
    allEvents: 'All events and errors',
    theDevice: 'The device itself',
    deletedJourneys: 'Journeys deleted',
    deletedEvents: 'Events deleted',
    deletedDevices: 'Devices deleted',
    otpTitle: 'OTP Code',
    otpOperator: 'Operator',
    otpSettings: 'Settings',
    otpValidFor: 'Valid for day',
    otpNoSerialNumber: 'This device does not have a serial number configured.',
    otpConfigureFirst: 'Configure now',
    otpCopied: 'OTP copied to clipboard',
    otpError: 'Error generating OTP',
    otpDate: 'Date',
  },
  categories: {
    kiosk_onpremise: 'On-Premise Kiosk',
    kiosk_online: 'Online Kiosk',
    guest_mobile: 'Guest Mobile',
    online_checkin: 'Online Check-in',
    mobile_desk: 'Mobile Desk',
    dispenser: 'Dispenser',
  },
  enums: {
    deviceType: {
      kiosk: 'Kiosk',
      dispenser: 'Dispenser',
      mobile: 'Mobile',
      online: 'Online',
      virtual: 'Virtual',
    },
    channel: {
      kiosk: 'Kiosk',
      dispenser: 'Dispenser',
      online: 'Online',
      airLobby: 'Air Lobby',
      airlobby: 'Air Lobby',
      mobileKiosk: 'Mobile Kiosk',
      mobilekiosk: 'Mobile Kiosk',
      virtual: 'Virtual',
    },
    status: {
      active: 'Active',
      inactive: 'Inactive',
      pendingActivation: 'Pending Activation',
      pendingactivation: 'Pending Activation',
    },
    source: {
      updater: 'Updater',
      manual: 'Manual',
    },
  },
  logs: {
    title: 'Device logs',
    subtitle: 'Logs for %{code}',
    backToDevices: 'Back to devices',
    noLogs: 'No logs found for this device',
    noLogsHint: 'The device may not have sent any logs yet, or the logging service may be unavailable.',
    seqError: 'Could not retrieve the device logs',
    level: 'Level',
    allLevels: 'All levels',
    from: 'From',
    to: 'To',
    count: 'Max results',
    refresh: 'Refresh',
    component: 'Component',
    origin: 'Origin',
    firmware: 'Firmware',
    serialNumber: 'Serial Number',
    result: 'Result',
    transaction: 'Transaction',
    steps: 'Steps',
    step: 'Step %{number}',
    properties: 'Properties',
    loading: 'Loading logs...',
  },

  // Connectivity board (public panel-link "Equipos" tab, `DeviceDashboardView`)
  dashboardView: {
    empty: 'No devices to show.',
    filter: {
      all: 'All (%{count})',
      connected: 'Connected (%{count})',
      disconnected: 'Disconnected (%{count})',
    },
  },
};
export default devices;